/* eslint-disable import/no-unresolved */
import { Tooltip } from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import { useMutation } from "react-query";
import { countryCall } from "src/services/Master";
import CustomAutocomplete from "src/shared/CustomAutocomplete";
import CustomDatePicker from "src/shared/CustomDatePicker";
// import CustomSelect from "src/shared/CustomSelect";
import CustomTextField from "src/shared/CustomTextField";

interface Props {
  formik: any;
  dob: string;
}

function NRIDetails({ formik, dob }: Props) {
  const [countryOptions, setCountryOptions] = useState([]);
  const { mutate: mutateCountry } = useMutation(countryCall, {
    retry: false,
    onSuccess: async (response, variables) => {
      const countryResponse = response.data;
      const countryOccupationArray = countryResponse.reduce(
        (acc: string[], result: Record<string, any>) => {
          acc.push(result?.name);
          return acc;
        },
        []
      );
      setCountryOptions(countryOccupationArray);
      if (response.data?.length) {
        const exactCountryData = await response.data?.filter(
          (country: Record<string, any>) => country?.name === variables?.name
        );
        formik.setFieldValue("nriDetails.currentCountryCode", exactCountryData[0]?.code);
      }
    }
  });

  const handleCountryChange = async (value: string) => {
    // console.log("entering country");
    await formik.setFieldValue("nriDetails.currentCountry", value);
    if (value) mutateCountry({ name: value });
  };

  return (
    <div>
      {/* Commented out the COVID section as it's no longer needed but can be reused if required. Below line is commented due to this */}
      {/* <p className="font-montserrat text-black text-base font-bold">NRI Details</p> */}
      <div className="mt-6">
        <div className="flex flex-col md:flex-row justify-between">
          <div className="w-full md:w-222/1000 mb-6 md:mb-0">
            {/* <CustomSelect
              requiredStar
              label="Current Country"
              className=""
              options={["India", "USA"]}
              // onChange={handleChange("nriDetails.currentCountry")}
              onChange={formik.handleChange}
              setFieldTouched={formik.setFieldTouched}
              name="nriDetails.currentCountry"
              value={formik.values.nriDetails?.currentCountry}
              error={formik.errors.nriDetails?.currentCountry}
              touched={formik.touched.nriDetails?.currentCountry}
            /> */}
            <CustomAutocomplete
              onChange={handleCountryChange}
              setFieldTouched={formik.setFieldTouched}
              label="Current Country"
              name="nriDetails.currentCountry"
              value={formik.values.nriDetails?.currentCountry}
              setFieldValue={formik.setFieldValue}
              error={formik.errors.nriDetails?.currentCountry}
              touched={formik.touched.nriDetails?.currentCountry}
              options={countryOptions}
            />
          </div>
          <div className="w-full md:w-222/1000 mb-6 md:mb-0">
            <CustomTextField
              requiredStar
              label="City Of Residence"
              className=""
              // onChange={handleChange("nriDetails.cityOfResidence")}
              onChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              value={formik.values.nriDetails?.cityOfResidence}
              name="nriDetails.cityOfResidence"
              error={formik.errors.nriDetails?.cityOfResidence}
              touched={formik.touched.nriDetails?.cityOfResidence}
            />
          </div>
          <Tooltip
            title="Last Date Of Entry To India"
            placement="top"
            classes={{ tooltipPlacementTop: "!m-0.5" }}
            PopperProps={{
              className: "!z-0"
            }}
          >
            <div className="w-full md:w-222/1000 mb-6 md:mb-0">
              <CustomDatePicker
                requiredStar
                disableFuture
                className=""
                minDate={dayjs(new Date(dob.split("/").reverse().join("-")))}
                // isSaveFlag
                value={formik.values.nriDetails?.lastDateOfEntryToIn}
                label="Last Date Of Entry To India"
                setFieldValue={formik.setFieldValue}
                name="nriDetails.lastDateOfEntryToIn"
                error={formik.errors.nriDetails?.lastDateOfEntryToIn}
                touched={formik.touched.nriDetails?.lastDateOfEntryToIn}
                setFieldTouched={formik.setFieldTouched}
              />
            </div>
          </Tooltip>
          <Tooltip
            title="Exit Date From India"
            placement="top"
            classes={{ tooltipPlacementTop: "!m-0.5" }}
            PopperProps={{
              className: "!z-0"
            }}
          >
            <div className="w-full md:w-222/1000">
              <CustomDatePicker
                // requiredStar
                // disableFuture
                disableField={
                  formik.values.nriDetails.lastDateOfEntryToIn === "" ||
                  formik.values.nriDetails.lastDateOfEntryToIn === "Invalid Date"
                }
                minDate={dayjs(
                  new Date(
                    formik.values.nriDetails.lastDateOfEntryToIn.split("/").reverse().join("-")
                  )
                )}
                className=""
                // isSaveFlag
                value={formik.values.nriDetails?.exitDateFromIndia}
                label="Exit Date From India"
                setFieldValue={formik.setFieldValue}
                name="nriDetails.exitDateFromIndia"
                error={formik.errors.nriDetails?.exitDateFromIndia}
                touched={formik.touched.nriDetails?.exitDateFromIndia}
                setFieldTouched={formik.setFieldTouched}
              />
            </div>
          </Tooltip>
        </div>
        <div className="mt-6">
          <div className="flex flex-col md:flex-row justify-between">
            <div className="w-full md:w-477/1000 mb-6 md:mb-0">
              <p className="mb-4 text-daintree font-montserrat text-sm font-medium">
                How long have you been staying abroad (Months)?*
              </p>
              <CustomTextField
                requiredStar
                label="Enter"
                className=""
                onChange={formik.handleChange}
                handleBlur={formik.handleBlur}
                value={formik.values.nriDetails?.durationOfStayAbroad}
                name="nriDetails.durationOfStayAbroad"
                error={formik.errors.nriDetails?.durationOfStayAbroad}
                touched={formik.touched.nriDetails?.durationOfStayAbroad}
              />
            </div>
            <div className="w-full md:w-477/1000 mb-6 md:mb-0">
              <p className="lg:mb-4 md:mb-9 text-daintree font-montserrat text-sm font-medium">
                What is purpose of your stay abroad?*
              </p>
              <CustomTextField
                requiredStar
                label="Enter"
                className=""
                onChange={formik.handleChange}
                handleBlur={formik.handleBlur}
                value={formik.values.nriDetails?.purposeOfStayAbroad}
                name="nriDetails.purposeOfStayAbroad"
                error={formik.errors.nriDetails?.purposeOfStayAbroad}
                touched={formik.touched.nriDetails?.purposeOfStayAbroad}
              />
            </div>
          </div>
        </div>
        <div className="mt-6">
          <p className="mb-4 text-daintree font-montserrat text-sm font-medium">
            What is purpose of taking insurance from India?*
          </p>
          <CustomTextField
            requiredStar
            label="Enter"
            className=""
            // onChange={handleChange("nriDetails.insurancePurpose")}
            onChange={formik.handleChange}
            handleBlur={formik.handleBlur}
            value={formik.values.nriDetails?.insurancePurpose}
            name="nriDetails.insurancePurpose"
            error={formik.errors.nriDetails?.insurancePurpose}
            touched={formik.touched.nriDetails?.insurancePurpose}
          />
        </div>
      </div>
    </div>
  );
}

export default NRIDetails;
